<template>
  <div id="root">
    <img id="imagine" src="@/assets/images/ssa_logo.png" alt="SSA logo" />
    <div id="mobile-container">
    <img id="imagine_mobile" src="@/assets/images/logo.png" alt="Logo mobile" />
    <div class="text_mobile">{{$t('about.text')}}</div>
    </div>
    <img class="path" :src="path" />
    <div id="egg">
      <div id="textbox">
        <h1>Soft Skills Academy 6</h1>
        <p>{{$t('about.text')}}</p>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1116.602"
        height="1006.807"
        viewBox="0 0 1116.602 1006.807"
      >
        <path
          id="Path_2177"
          data-name="Path 2177"
          d="M2249-489.333s-200.515,199.273-458.091,238.667-409.091-3.03-506.061,45.455S1136.364.848,1133.333,106.909s27.273,212.121,103.03,290.909,198.3,98.182,236.364,106.061,403.03,78.7,776.273-203.121C2250.641,306.352,2249-489.333,2249-489.333Z"
          transform="translate(-1133.128 489.333)"
          fill="#0d9599"
        />
      </svg>
    </div>
    <div class="extra-space"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: require("@/assets/images/HomeHeroPath.svg"),
    };
  },
};
</script>

<style scoped lang="scss">
#root {
  display: flex;
  height: 55vw;
  background-color: #0d2a4c;
  align-items: center;
  position: relative;
  z-index: 0;
}
#imagine_mobile {
  display: none;
}
.path {
  display: none;
}
.text_mobile {
  display: none;
}
svg {
  height: 50vw;
  width: 90vw;
}
#egg {
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 45vw;
  justify-content: center;
}
#imagine {
  position: absolute;
  margin-top: 4vw;
  left: 12vw;
  height: 30vw;
}
#textbox {
  margin-left: 2vw;
  // margin-left:20vw;
  width: 45vw;
  position: absolute;
  padding: 4vw;
  text-align: center;
}
h1 {
  margin-top: 8vw;
  font-size: 3.3vw;
  color: white;
  font-family: Acumin Variable Concept;
}
p {
  margin-top: 2.8vw;
  margin-bottom: 0;
  color: white;
  font-size: 1.1vw;
  font-family: Acumin Variable Concept;
}

@media only screen and (max-width: 1024px) {
  #root {
    width: 100%;
    background-image: url("../../assets/images/imagine-fundal-min.png");
    background-position: center;
    display: flex;
    height: 90vh;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  #imagine {
    display: none;
  }

  #mobile-container {
    position: absolute;
    top: 0;
  }

  .text_mobile {
    width: 90vw;
    text-align: center;
    display: block;
    color: white;
    font-size: calc(11px + (17 - 11)*((100vh - 640px)/(1024 - 640)));
    font-family: Acumin Variable Concept;
  }
  #egg {
    display: none;
  }

  #imagine_mobile {
    display: block;
    width: 70vw;
    height: 32vw;
    margin-bottom: 5vh;
    margin-top: 15vh;
    margin-right: 0!important;
  }
  .path {
    display: block;
    position: absolute;
    width: 100%;
    height: auto;
    bottom: -2vh;
  }
  //foarte carpit but who cares at this point?
  .extra-space {
    width: 100vw;
    height: 3vh;
    position: absolute;
    bottom: -4vh;
    background-color: #0d2a4c;
    z-index: 1000;
  }
}
</style>